import {SalesLeaguePeriod} from '@dms/api/sales';
import {salesLeagueRoutes} from '@dms/routes';

import {SALES_LEAGUE_BRANCH_ID_QUERY_PARAM} from '../constants/SALES_LEAGUE_BRANCH_ID_QUERY_PARAM';
import {SALES_LEAGUE_PERIOD_QUERY_PARAM} from '../constants/SALES_LEAGUE_PERIODS';

/**
 * The rep leaderboard for one branch. The period travels with the link, so drilling into a
 * branch does not silently reset the board to the default period.
 */
export function buildBranchBoardDrillDownPath(branchId: string, period: SalesLeaguePeriod) {
  const params = new URLSearchParams({
    [SALES_LEAGUE_PERIOD_QUERY_PARAM]: period,
    [SALES_LEAGUE_BRANCH_ID_QUERY_PARAM]: branchId,
  });

  return `${salesLeagueRoutes.overview}?${params.toString()}`;
}
